import server_api from "data/server_apis/server_api";

export const createSuperAdminProfile = (data) => {
  const resp = server_api.post("/accounts/super-admin", data);
  return resp;
};

export const createAdminProfile = (data) => {
  const resp = server_api.post("/accounts/admin", data);
  return resp;
};

export const createDistributorProfile = (data) => {
  const resp = server_api.post("/accounts/distributor", data);
  return resp;
};
export const createMachineAdminProfile = (data) => {
  const resp = server_api.post("/accounts/machine-admin", data);
  return resp;
};
export const createLocationAdminProfile = (data) => {
  const resp = server_api.post("/accounts/location-admin", data);
  return resp;
};
export const createFillingPersonProfile = (data) => {
  const resp = server_api.post("/accounts/filling-person", data);
  return resp;
};

export const getSuperAdminProfile = (id) => {
  const resp = server_api.get(`/accounts/super-admin/${id}`);
  return resp;
};

export const getAdminProfile = (id) => {
  const resp = server_api.get(`/accounts/admin/${id}`);
  return resp;
};

export const getDistributorProfile = (id) => {
  const resp = server_api.get(`/accounts/distributor/${id}`);
  return resp;
};
export const getMachineAdminProfile = (id) => {
  const resp = server_api.get(`/accounts/machine-admin/${id}`);
  return resp;
};
export const getLocationAdminProfile = (id) => {
  const resp = server_api.get(`/accounts/location-admin/${id}`);
  return resp;
};
export const getFillingPersonProfile = (id) => {
  const resp = server_api.get(`/accounts/filling-person/${id}`);
  return resp;
};

export const updateSuperAdminProfile = (id, data) => {
  const resp = server_api.patch(`/accounts/super-admin/${id}`, data);
  return resp;
};

export const updateAdminProfile = (id, data) => {
  const resp = server_api.patch(`/accounts/admin/${id}`, data);
  return resp;
};

export const updateDistributorProfile = (id, data) => {
  const resp = server_api.patch(`/accounts/distributor/${id}`, data);
  return resp;
};
export const updateMachineAdminProfile = (id, data) => {
  const resp = server_api.patch(`/accounts/machine-admin/${id}`, data);
  return resp;
};
export const updateLocationAdminProfile = (id, data) => {
  const resp = server_api.patch(`/accounts/location-admin/${id}`, data);
  return resp;
};
export const updateFillingPersonProfile = (id, data) => {
  const resp = server_api.patch(`/accounts/filling-person/${id}`, data);
  return resp;
};
